import api from '../../../lib/axios';
import { BaseResponse } from '../../../lib/api-contract';
import { EntitlementProfile } from '../types';
import { MerchantSubscriptionPayload } from "../types/subscription";

const ENTITLEMENT_ENDPOINT = '/v1/merchant/local-merchant/entitlements';
const MERCHANT_SUBSCRIPTION_ENDPOINT = "/v1/merchant/local-merchant/subscription";

export const fetchCurrentEntitlementProfile = async (signal?: AbortSignal): Promise<BaseResponse<EntitlementProfile | null>> => {
    const response = await api.get<BaseResponse<EntitlementProfile | null>>(ENTITLEMENT_ENDPOINT, { signal });
    return response.data;
};

export const fetchMerchantSubscription = async (): Promise<
  BaseResponse<MerchantSubscriptionPayload | null>
> => {
  const response = await api.get<BaseResponse<MerchantSubscriptionPayload | null>>(
    MERCHANT_SUBSCRIPTION_ENDPOINT,
  );
  return response.data;
};
